module.exports = __webpack_public_path__ + "img/C4.8880d158.svg";